import { render } from "./storage-location-page.vue?vue&type=template&id=1be71370&scoped=true"
import script from "./storage-location-page.vue?vue&type=script&lang=js"
export * from "./storage-location-page.vue?vue&type=script&lang=js"

import "./storage-location-page.vue?vue&type=style&index=0&id=1be71370&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be71370"]])

export default __exports__